var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatHistoryLine = function SvgChatHistoryLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 2.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1-3.531-.881L2.5 17.5l.882-3.967A7.5 7.5 0 0 1 10 2.5M10 4a6 6 0 0 0-5.295 8.825l.263.49-.492 2.21 2.21-.491.49.262A6 6 0 1 0 10 4m.75 2.25V10h3v1.5h-4.5V6.25z"
  })));
};
export default SvgChatHistoryLine;